<div class="modal-header">
  <h4 class="col-11 modal-title" id="myModalLabel">
    <img alt="Brand" src="{{directoryImages}}/assets/images/dhl-official2.png">
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form #frm="ngForm">
  <div class="modal-body">
    <ng-container *ngFor="let change of changes">
      <span [innerHtml]="change.html">
      </span>
      <br>
    </ng-container>
    <br>
    <span [innerHtml]="'ModifyDelivery.ConfirmationWarning' | translate"></span>
    <br>
    <br>
    <div class="form-group row noPL">
      <label for="zipCode" class="col-5 ">{{'ModifyDelivery.DestinationZipCode' | translate}}</label>
      <div class="col-7 ">
        <input class="form-control" [mask]="zipCodeMask" [(ngModel)]="zipCode" name="zipCode"
          [elementoErrores]="errorCodigoPostal" maxlength="9">
      </div>
      <span class="label-invalido col-xs-12" #errorCodigoPostal></span>
    </div>
    <div class="checkbox col-12 noPL mt-4">
      <label>
        <input type="checkbox" style="margin-right: 5px; top:2px;" [(ngModel)]="acceptPolicyPrivacy"
          [elementoErrores]="errorPoliticaPrivacidad" name="acceptPolicyPrivacy">
        <span [innerHtml]="'ModifyDelivery.PrivacyPolicyHtml' | translate"></span>
      </label>
      <br>
      <span class="label-invalido" #errorPoliticaPrivacidad></span>
    </div>
  </div>
  <div class="row modal-footer " style="justify-content: center;">
    <div class="btnSentStatus d-grid col-sm-8 offset-sm-2 col-12 pt-2" style="margin-top: 0;">
      <button type="button" class="btn btn-default btn-block" style="width: -webkit-fill-available;"
        (click)="confirmExit(frm)">
        {{'ModifyDelivery.ConfirmExit' | translate}}
      </button>
      <button *ngIf="moreChangesCanBeMade" type="button" class="btn btnDefault btn-block"
        style="width: -webkit-fill-available; margin-bottom: 5px;" (click)="confirmChange(frm)">
        {{'ModifyDelivery.ConfirmChanges' | translate}}
      </button>
      <button type="button" class="btn btnDefault btn-block" style="width: -webkit-fill-available; margin-bottom: 5px;"
        (click)="modal.hide()">
        {{'Shared.Cancel' | translate}}
      </button>

    </div>
  </div>
</form>